import React from "react";
import "./_static/DateRangeFilter.css"

function DateRangeFilter(props) {

    return (
        <div>
            <input type="date" name={props.name + '_after'} onChange={props.onChange} value={props.value.after}/>
             -
            <input type="date" name={props.name + '_before'} onChange={props.onChange} value={props.value.before}/>
        </div>
    )
}

export default DateRangeFilter
